import { StyledButton } from '@/components/styled/button';
import { FormPublicDesignFragment } from '@/graphql/fragment/form.public.fragment';
import { Typography, Grid, Box } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Supporter from '../../pillars-of-product/components/Supporter';
import footerBg1 from '../assets/footer-1.png';
import footerBg2 from '../assets/footer-bg.png';
import avatar1 from '../assets/marta.png';
import avatar2 from '../assets/rob.jpg';

interface Props {
  design: FormPublicDesignFragment;
}

export const Footer: React.FC<Props> = ({ design }) => {
  return (
    <>
      <Grid
        container
        sx={{
          justifyContent: 'center',
          margin: '100px 0',
        }}
      >
        <Grid
          sx={{
            maxWidth: '1200px',
            padding: '0 30px',
            width: '100%',
            flexDirection: 'row',
            display: 'flex',
          }}
        >
          <Grid
            item
            xs={4}
            sx={{
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Typography
              style={{
                color: design.colors.question,
                fontSize: '40px',
                lineHeight: '50px',
                width: '250px',
              }}
            >
              Tell us what you think!
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography
              style={{
                color: design.colors.question,
                fontSize: '24px',
                maxWidth: '660px',
                fontWeight: '300',
              }}
            >
              We&apos;re always making{' '}
              <span
                style={{
                  fontWeight: '700',
                }}
              >
                Design Skill Stack
              </span>{' '}
              better. Have feedback on the topics, the results, or want to get
              involved? Reach out!
            </Typography>
            <StyledButton
              background={design.colors.button}
              $buttonColor={design.colors.buttonText}
              highlight={design.colors.buttonActive}
              href={
                'mailto:robaumgartner@deloitte.com?subject=Design Skill Stack Feedback'
              }
              type='submit'
              className={'continue-button'}
              style={{ textDecoration: 'none', width: '210px' }}
            >
              {'Provide Feedback'}
              <ArrowForwardIcon
                sx={{ height: '20px', width: '15px', marginLeft: '8px' }}
              />
            </StyledButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          justifyContent: 'center',
          backgroundColor: '#0085D0',
          padding: '150px 0 75px',
          position: 'relative',
          backgroundImage: `url(${footerBg2})`,
          backgroundSize: 'cover',
        }}
      >
        <Grid
          sx={{
            maxWidth: '1200px',
            padding: '0 30px',
            width: '100%',
            minHeight: '300px',
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: '-230px',
              left: '0px',
              width: '381px',
              height: '479px',
              maxWidth: '508px',
              display: { xs: 'none', lg: 'block' },
              backgroundImage: `url(${footerBg1})`,
              backgroundSize: 'cover',
            }}
          ></Box>
          <Grid
            item
            xs={6}
            sx={{
              marginTop: '100px',
            }}
          >
            <Typography
              style={{
                color: design.colors.question,
                fontSize: '36px',
                maxWidth: '500px',
              }}
            >
              Want to learn more about Design Skill Stack? Get in touch with the
              team.
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-evenly',
              marginTop: '100px',
            }}
          >
            <Supporter
              name='Marta Coleman'
              position='Studio Senior Lead | Chicago'
              email='marcoleman@deloitte.com'
              picture={avatar1}
              design={design}
            />
            <Supporter
              name='Rob Baumgartner'
              position='Studio Senior | New York'
              email='robaumgartner@deloitte.com'
              picture={avatar2}
              design={design}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
